var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WebPanelPage',{staticClass:"focus-route",attrs:{"title":"Focus example","focus":""}},[_c('div',{staticClass:"flex mb5"},[_c('BreadcrumbNav',{attrs:{"items":[
        { name: 'Home', routerLink: { name: 'home' } },
        { name: 'Focus Page' } ]}})],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"f-title"},[_vm._v("Hey I'm a focus page")])])])}
var staticRenderFns = []

export { render, staticRenderFns }